module.exports = __webpack_public_path__ + "static/media/image (35).4f81c602.jpg";